export const TEXTS = {
  NEWER_VERSION_EXISTS: 'Newer version exists',
  CLICK_TO_READ_REPORT: 'Click to read the report',
  FROM_SOP: 'From the SOP',
  FROM_STAGE_INSTRUCTIONS: 'From the conductor stage instructions',
  FROM_GENERAL_INSTRUCTIONS: 'From the conductor general instructions',
  EXPERT_CHIP_LABEL: (name: string, versionDate?: string): string => (versionDate ? `${name} · ${versionDate}` : name),
};
